import React from 'react'

function Icon({opacity='0.5'}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="#202020"
        fillOpacity={opacity}
        d="M16.893 18.192A8.978 8.978 0 0112 19.637c-4.485 0-8.217-3.293-9-7.637a9.37 9.37 0 012.778-5.147L3.176 4.201 4.353 3l16.47 16.8-1.177 1.2-2.754-2.808h.001zM6.955 8.054A7.641 7.641 0 004.699 12a7.703 7.703 0 001.523 3.159 7.508 7.508 0 002.75 2.126 7.362 7.362 0 006.708-.332l-1.687-1.72a3.685 3.685 0 01-4.642-.531 3.88 3.88 0 01-.52-4.735L6.955 8.054zm5.805 5.921l-2.697-2.75a2.16 2.16 0 00-.1 1.208c.083.404.28.775.566 1.067.286.292.65.492 1.046.577.396.084.808.048 1.184-.102h.001zm6.566 1.921l-1.19-1.213A7.655 7.655 0 0019.3 12a7.715 7.715 0 00-1.249-2.8 7.547 7.547 0 00-2.23-2.07 7.35 7.35 0 00-5.858-.783L8.65 5.008A8.984 8.984 0 0112 4.364c4.485 0 8.217 3.292 9 7.636a9.382 9.382 0 01-1.674 3.896zM11.77 8.19c.53-.034 1.06.048 1.556.24.496.191.946.488 1.322.87.375.383.666.843.854 1.349.187.506.268 1.047.235 1.587l-3.968-4.046z"
      ></path>
    </svg>
  )
}

export default Icon
